package ld.scenes;

import pixi.core.renderers.SystemRenderer;
import pixi.core.display.Container;
import pixi.core.graphics.Graphics;
import pixi.core.textures.Texture;
import pixi.core.sprites.Sprite;
import pixi.extras.BitmapText;

import tweenx909.TweenX;

import stocking.AudioManager;
import stocking.Scene;
import stocking.SceneManager;
import ld.GameState;

class MapScene extends Scene
{
	var overworldData : Array<ld.Types.LDOverworldFile>;

	var containerMapNodes : Container = new Container();
	var containerMapNodeLines : Container = new Container();

	var nodeNameText : BitmapText;
	var nodeDescText : BitmapText;

	var portraitPlant : Sprite;
	var portraitBird : Sprite;
	var portraitSpider : Sprite;

	var incr : Int = 0;

	public function new( renderer : SystemRenderer, stage : Container )
	{
		super( renderer, stage );

		container.addChild(containerMapNodes);

		strMusicTrack = "assets/music/On My Way.mp3";
	
	}
	



    public override function preload()
    {
		loaderImages = [
			{ filename: "assets/bunny.png"},
			{ filename: "assets/Level_Select_Border.png"},
			{ filename: "assets/Large_Button.png"},
		];

		loaderData = [
			{ filename: "assets/data/overworld.json", alias: "overworlddata"},
		];

		loaderFonts = [
			"assets/khdot16.fnt",
			"assets/khdot12.fnt",
		];

		loaderSfx = [
				"assets/sfx/MENU B_Select.wav",
			"assets/sfx/MENU A_Select.wav",
			"assets/sfx/MENU_Pick.wav",
			"assets/sfx/Menu Select 1.wav",
		];
		
		super.preload();
    }

	public override function enter()
	{
		super.enter();

		if( !dataCache.exists('overworlddata') )
		{
			throw("tried to enter before overworlddata loaded. How??");
		}

		var bg = new Sprite( Texture.fromImage( "assets/Level_Select_Border.png" ));
		container.addChild(bg);

		overworldData = dataCache.get('overworlddata');

		for( node in overworldData )
		{
			if( incr++ > GameState.instance.completedLevels )
				break;
			DrawMapNode(node);
		}

		nodeNameText = new BitmapText( "", { font: "16px khdot16", align: BitmapTextAlign.CENTER } );
		nodeNameText.position.x = 440;
		nodeNameText.position.y = 510;
		
		nodeDescText = new BitmapText( "", { font: "16px khdot16", align: BitmapTextAlign.CENTER } );
		nodeDescText.position.x = 440;
		nodeDescText.position.y = 580;

		nodeDescText.scale.x = nodeDescText.scale.y = 2;
		nodeNameText.scale.x = nodeNameText.scale.y = 2;
		
		container.addChild(nodeNameText);
		container.addChild(nodeDescText);

		portraitPlant = new Sprite( Texture.fromImage( "assets/Plant_Girl_Portrait_spr.png" ) );
		portraitPlant.scale.x *= -1;

		portraitPlant.x = 250;
		portraitPlant.y = 74;

		portraitBird = new Sprite( Texture.fromImage( "assets/Bird_Girl_Portrait_spr.png" ) );
		portraitBird.scale.x *= -1;


		portraitBird.x = 392;
		portraitBird.y = 193;
		
		portraitSpider = new Sprite( Texture.fromImage( "assets/Spider_Girl__Portrait_spr.png" ) );
		
		portraitSpider.scale.x *= -1;
		
		
		portraitSpider.x = 250;
		portraitSpider.y = 296;



		container.addChild(portraitPlant);
		container.addChild(portraitBird);
		container.addChild(portraitSpider);

		//if( containerMapNodes.height > 400 )
		//{
			containerMapNodes.y -= containerMapNodes.height / 2;
		//}
		


		
	}


	public override function tick( delta : Float )
	{
		
	}

	private function DrawMapNode(node: ld.Types.LDOverworldFile)
	{

		
		
		var parents = GetParentNodes( node.id );
		var ctn = new Container();

		var mapNodeCenterX = 10;
		var mapNodeCenterY = 10;		

		// Sprite
		ctn = Util.MakeBigButton( node.name );

		ctn.x = 580;
		ctn.y = 50 + 100 * incr;
		
		ctn.interactive = true;
		ctn.click = ctn.tap = function( event : pixi.interaction.InteractionEvent ) { 
			AudioManager.instance.play("assets/sfx/MENU A_Select.wav");
			TweenX.to( ctn, {alpha: 0}).time(0.5).onFinish(function(){

				GameState.instance.level = node.id;
				
				SceneManager.instance.transitionToScene(new GameScene(renderer, stage));
			});
		};

		ctn.mouseover = function( event : pixi.interaction.InteractionEvent ) { 
			// @todo juice
			AudioManager.instance.play("assets/sfx/MENU_Pick.wav");
			nodeNameText.text = node.name;
			nodeDescText.text = node.description;
		};

		
		containerMapNodes.addChild(ctn);

		
		// @todo draw lines
	}

	private function GetParentNodes( nodeId: String ) : Array<ld.Types.LDOverworldFile>
	{
		var out :Array<ld.Types.LDOverworldFile> = [];

		for( node in overworldData )
		{
			if( node.id == nodeId )
				out.push( node );
		}

		return out;
	}

}
